<template>
  <div>
    <inputs :title="title" :type="type" />
  </div>
</template>

<script>
import Inputs from "./components/Inputs";
export default {
  components: {
    Inputs,
  },
  data() {
    return {
      title: "Scan Fabric For C & C Cutting",
      type: "c_and_c_cutting",
    };
  },
};
</script>
